import { render, staticRenderFns } from "./PieCard.vue?vue&type=template&id=1f80123a&scoped=true&"
import script from "./PieCard.vue?vue&type=script&lang=js&"
export * from "./PieCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f80123a",
  null
  
)

export default component.exports